import clsx from 'clsx';

interface ContentProps {
  heading: string;
  isReview?: boolean;
}

const CourseHeading: React.FC<ContentProps> = ({
  heading,
  isReview = false,
}) => {
  return (
    <div className={clsx(isReview ? '' : 'mb-5', 'flex gap-x-3  items-center')}>
      <h2 className='font-semibold md:font-bold text-lg lg:text-xl 2xl:text-2xl '>
        {heading}
      </h2>
    </div>
  );
};

export default CourseHeading;
